export default (axios) => ({
  getProjectApplicationQuestions(jobHandleId, query) {
    return axios.get(`/v1/api/projectApplication/${jobHandleId}/question`, {
      params: {
        ...query
      }
    })
  }
})
